import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ROUTE_SCROLL_CONTAINER = '[data-route-scroll-container="true"]';

const ScrollToTop = () => {
  const { hash, pathname } = useLocation();

  useLayoutEffect(() => {
    window.requestAnimationFrame(() => {
      if (hash) {
        const target = document.getElementById(hash.slice(1));
        if (target) {
          target.scrollIntoView({ block: 'start' });
          return;
        }
      }

      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.querySelector<HTMLElement>(ROUTE_SCROLL_CONTAINER)?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });
  }, [hash, pathname]);

  return null;
};

export default ScrollToTop;
